import { useState } from "react";
import EnrollModal from "./modals/EnrollModal";

const DuiProgram = ({ duiData, slug }) => {
  const [popupData, setPopupData] = useState(null);

  const openPopup = (duiData) => {
    setPopupData(duiData);
  };
  
  return (
    <>
      <div className="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-4 col-xl-4 mb-4 mb-md-0">
        <div className="d-flex justify-content-between flex-column course-detail-blog">
          <div className=" text-center">
            <img src={duiData.icon_url} alt="" className="mb-md-3 mb-2" />
            <h5 className="course-detail-heading text-capitalize mb-md-3 mb-3">
              {duiData.name}
            </h5>
            {/* <div dangerouslySetInnerHTML={{ __html: duiData.short_description.replace(/\n/g, "<br />") }}></div> */}
            <p
              dangerouslySetInnerHTML={{
                __html: duiData.short_description.replace(/\n/g, "<br />"),
              }}
            ></p>
          </div>
          <div className="detail-btn d-flex align-items-center justify-content-space-between flex-column">
            {duiData && duiData.price && (
              <div className="price mb-md-4 mb-4"> ${duiData.price}</div>
            )}
            {duiData.long_description ?
             (
                <a
                  onClick={() => openPopup(duiData)}
                  className="btn small-btn d-flex align-items-center justify-content-center"
                  data-bs-toggle="modal"
                  data-bs-target="#more-info"
                >
                  CALL TO ENROLL
                  <i className="fa-solid fa-circle-chevron-right"></i>
                </a>
              ) : (
                <a href={duiData.register_url}  target="_blank" rel="noreferrer" className="btn small-btn d-flex align-items-center justify-content-center">
                  Get Started
                  <i className="fa-solid fa-circle-chevron-right"></i>
                </a>
              )}
          </div>
        </div>
        {popupData && popupData.long_description && <EnrollModal lessonData={popupData}/>}
      </div>
    </>
  );
};

export default DuiProgram;
